/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dialogDeleteTenant.vue?vue&type=template&id=3240abf2&scoped=true"
import script from "./dialogDeleteTenant.vue?vue&type=script&lang=js"
export * from "./dialogDeleteTenant.vue?vue&type=script&lang=js"
import style0 from "./dialogDeleteTenant.vue?vue&type=style&index=0&id=3240abf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3240abf2",
  null
  
)

export default component.exports